module.exports = __webpack_public_path__ + "img/replacement.32310872.svg";